export default __webpack_public_path__ + "static/media/481927e1eccefb145bb0b977c27a8115.png";